import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchGroupNames, addGroupName, deleteGroupName } from '../actions/customers'

const GroupNamesModal = ({ onClose, customers, fetchGroupNames, addGroupName, deleteGroupName }) => {
  const [newName, setNewName] = useState('')
  const [newLabel, setNewLabel] = useState('')
  const [error, setError] = useState(null)
  const [confirmDelete, setConfirmDelete] = useState(null)

  useEffect(() => {
    fetchGroupNames()
  }, [fetchGroupNames])

  const groupNames = customers.groupNames || []
  const loading = customers.groupNamesLoading

  const handleAdd = async (e) => {
    e.preventDefault()
    setError(null)
    if (!newName.trim() || !newLabel.trim()) {
      setError('El código y el nombre son obligatorios')
      return
    }
    const result = await Promise.resolve(addGroupName(newName.trim(), newLabel.trim()))
    if (result && result.error) {
      setError(result.error.message || 'Error al crear el grupo')
      return
    }
    setNewName('')
    setNewLabel('')
  }

  const handleDelete = async (name) => {
    setError(null)
    const result = await Promise.resolve(deleteGroupName(name))
    if (result && result.error) {
      setError(result.error.message || 'Error al eliminar el grupo')
    }
    setConfirmDelete(null)
  }

  return (
    <div
      style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 8, padding: 24, width: '95%', maxWidth: 560, maxHeight: '85vh', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
      >
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ margin: 0, color: '#004f75' }}>
            <i className="fas fa-layer-group mr-2" />
            Gestionar Grupos
          </h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#666' }}>✕</button>
        </div>

        {error && (
          <div style={{ color: '#b22222', marginBottom: 12, padding: '8px 12px', background: '#fff5f5', borderRadius: 4, border: '1px solid #fca5a5', fontSize: '0.875rem' }}>
            {error}
          </div>
        )}

        {/* Add form */}
        <form onSubmit={handleAdd} style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          <input
            type="text"
            value={newName}
            onChange={(e) => setNewName(e.target.value.toUpperCase())}
            placeholder="Código (ej: ASPRO)"
            style={{ flex: '0 0 130px', padding: '7px 10px', border: '1px solid #ccc', borderRadius: 6, fontSize: '0.875rem', textTransform: 'uppercase' }}
          />
          <input
            type="text"
            value={newLabel}
            onChange={(e) => setNewLabel(e.target.value)}
            placeholder="Nombre (ej: Aspro Parks)"
            style={{ flex: 1, padding: '7px 10px', border: '1px solid #ccc', borderRadius: 6, fontSize: '0.875rem' }}
          />
          <button
            type="submit"
            disabled={loading}
            style={{ padding: '7px 16px', background: '#004f75', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem', whiteSpace: 'nowrap' }}
          >
            <i className="fas fa-plus mr-1" />
            Añadir
          </button>
        </form>

        {/* List */}
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {loading && !groupNames.length ? (
            <div style={{ textAlign: 'center', padding: 32, color: '#666' }}>Cargando...</div>
          ) : groupNames.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 32, color: '#999', fontSize: '0.875rem' }}>
              No hay grupos definidos. Añade el primero arriba.
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ backgroundColor: '#f0f4fa' }}>
                  <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#004f75' }}>Código</th>
                  <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#004f75' }}>Nombre</th>
                  <th style={{ padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: '#004f75' }}></th>
                </tr>
              </thead>
              <tbody>
                {groupNames.map((g, idx) => (
                  <tr key={g._id} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fb', borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '8px 12px', fontFamily: 'monospace', fontWeight: 600, color: '#004f75' }}>{g.name}</td>
                    <td style={{ padding: '8px 12px', color: '#333' }}>{g.label}</td>
                    <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                      {confirmDelete === g.name ? (
                        <span style={{ display: 'inline-flex', gap: 6 }}>
                          <button
                            onClick={() => handleDelete(g.name)}
                            style={{ padding: '4px 10px', background: '#dc2626', color: '#fff', border: 'none', borderRadius: 5, cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600 }}
                          >
                            Confirmar
                          </button>
                          <button
                            onClick={() => setConfirmDelete(null)}
                            style={{ padding: '4px 10px', background: '#e5e7eb', color: '#333', border: 'none', borderRadius: 5, cursor: 'pointer', fontSize: '0.8rem' }}
                          >
                            Cancelar
                          </button>
                        </span>
                      ) : (
                        <button
                          onClick={() => setConfirmDelete(g.name)}
                          style={{ padding: '4px 10px', background: 'transparent', color: '#dc2626', border: '1px solid #dc2626', borderRadius: 5, cursor: 'pointer', fontSize: '0.8rem' }}
                        >
                          <i className="fas fa-trash" />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid #eee', fontSize: '0.8rem', color: '#888' }}>
          Los grupos definidos aquí aparecen en el selector de todos los clientes y usuarios GROUP.
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  customers: state.customers,
})

const mapDispatchToProps = (dispatch) => ({
  fetchGroupNames: bindActionCreators(fetchGroupNames, dispatch),
  addGroupName: bindActionCreators(addGroupName, dispatch),
  deleteGroupName: bindActionCreators(deleteGroupName, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(GroupNamesModal)
